export const makeFullName = (firstname: string, lastname: string): string =>
  `${firstname || ''} ${lastname || ''}`.trim()
